export enum CancellationTypeEnum {
  FullRefund = 'full',
  PartialRefund = 'partial',
  NoRefund = 'none',
  NegativeRefund = 'negative',
}
